module.exports = __webpack_public_path__ + "media/headLeft4.713f1d82.mp4";